export const hotTags = [
  { id: 1, label: '爆', slug: 'trending' },
  { id: 2, label: '网红黑料', slug: 'wanghong' },
  { id: 3, label: '明星八卦', slug: 'mingxing' },
  { id: 4, label: '独家', slug: 'dujia' },
  { id: 5, label: '直播翻车', slug: 'zhibo' },
  { id: 6, label: '娱乐圈', slug: 'yule' },
  { id: 7, label: '社会热点', slug: 'shehui' },
  { id: 8, label: '新瓜', slug: 'xingua' },
];

export const exposeCards = [
  {
    id: 1,
    title: '某千万粉丝主播直播间突然被封，背后原因曝光',
    summary: '据知情人士透露，该主播因涉及违规带货被平台永久封禁，累计罚款超千万',
    category: '网红黑料',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20streaming%20studio%20with%20red%20warning%20alert%20on%20computer%20screen%2C%20dark%20atmosphere%2C%20cyberpunk%20aesthetic%2C%20neon%20pink%20accents%2C%20mysterious%20silhouette%2C%20editorial%20photography%20with%20high%20contrast%2C%20dramatic%20lighting%2C%20suspenseful%20mood&width=800&height=600&seq=expose-card-01&orientation=landscape',
    time: '12分钟前',
    reads: '85.2万',
  },
  {
    id: 2,
    title: '顶流女星深夜密会神秘男子，经纪人紧急公关',
    summary: '狗仔拍到某一线女星与圈外男子共进晚餐后同回酒店，工作室连夜发声明',
    category: '明星八卦',
    tag: '独家',
    image: 'https://readdy.ai/api/search-image?query=Paparazzi%20night%20photography%20of%20luxury%20hotel%20entrance%2C%20blurred%20figures%2C%20warm%20golden%20street%20lights%2C%20mysterious%20atmosphere%2C%20high%20contrast%20editorial%20style%2C%20dark%20corners%2C%20dramatic%20mood&width=800&height=600&seq=expose-card-02&orientation=landscape',
    time: '28分钟前',
    reads: '120.6万',
  },
  {
    id: 3,
    title: '知名综艺录制现场爆发冲突，两位导师当场翻脸',
    summary: '综艺节目录制中途，两位评审因选手淘汰问题激烈争执，节目组被迫暂停',
    category: '娱乐圈',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20bright%20stage%20lights%2C%20two%20people%20in%20heated%20argument%20silhouette%2C%20dramatic%20red%20and%20blue%20lighting%20contrast%2C%20reality%20show%20atmosphere%2C%20intense%20confrontation%2C%20editorial%20photography&width=800&height=600&seq=expose-card-03&orientation=landscape',
    time: '45分钟前',
    reads: '96.3万',
  },
  {
    id: 4,
    title: '网红品牌被曝使用过期原料，生产线视频流出',
    summary: '某网红自创美妆品牌代工厂内部视频曝光，生产环境令人震惊，品牌方紧急回应',
    category: '社会热点',
    tag: '网红黑料',
    image: 'https://readdy.ai/api/search-image?query=Abandoned%20factory%20interior%20with%20dim%20lighting%2C%20industrial%20machinery%2C%20mysterious%20atmosphere%2C%20dark%20industrial%20aesthetic%2C%20investigative%20journalism%20style%2C%20gritty%20texture%2C%20high%20contrast&width=800&height=600&seq=expose-card-04&orientation=landscape',
    time: '1小时前',
    reads: '210.8万',
  },
  {
    id: 5,
    title: '某男团队长恋情曝光，女友竟是圈内知名经纪人',
    summary: '粉丝拍到男团成员与女经纪人牵手逛街，公司回应称系正常同事关系',
    category: '明星八卦',
    tag: '独家',
    image: 'https://readdy.ai/api/search-image?query=Couple%20walking%20hand%20in%20hand%20on%20busy%20shopping%20street%2C%20blurred%20crowd%20background%2C%20warm%20afternoon%20sunlight%2C%20paparazzi%20style%20candid%20photography%2C%20romantic%20atmosphere%2C%20soft%20focus&width=800&height=600&seq=expose-card-05&orientation=landscape',
    time: '2小时前',
    reads: '178.4万',
  },
  {
    id: 6,
    title: '热门短剧演员被曝学历造假，多所高校回应未查询到',
    summary: '自称名校毕业的当红短剧演员，被网友扒出学历存疑，当事人尚未回应',
    category: '网红黑料',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=University%20diploma%20on%20dark%20desk%20with%20spotlight%2C%20dramatic%20shadow%2C%20mysterious%20investigative%20mood%2C%20film%20noir%20lighting%2C%20question%20mark%20shadow%2C%20suspenseful%20atmosphere&width=800&height=600&seq=expose-card-06&orientation=landscape',
    time: '3小时前',
    reads: '67.9万',
  },
  {
    id: 7,
    title: '某卫视跨年晚会阵容泄露，多位一线艺人确认加盟',
    summary: '内部工作人员曝光晚会节目单，包含多位顶流歌手和演员的表演安排',
    category: '娱乐圈',
    tag: '新瓜',
    image: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20colorful%20spotlights%20and%20laser%20effects%2C%20empty%20arena%20before%20show%2C%20backstage%20vibe%2C%20dramatic%20purple%20and%20gold%20lighting%2C%20anticipation%20atmosphere&width=800&height=600&seq=expose-card-07&orientation=landscape',
    time: '4小时前',
    reads: '55.1万',
  },
  {
    id: 8,
    title: '吃播大胃王被曝催吐实锤，粉丝集体脱粉回踩',
    summary: '网友在餐厅偶遇某知名吃播，拍到其饭后催吐画面，引发全网热议',
    category: '网红黑料',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Restaurant%20bathroom%20door%20slightly%20open%20with%20dramatic%20light%20spilling%20out%2C%20mysterious%20atmosphere%2C%20dark%20corridor%2C%20investigative%20style%2C%20high%20contrast%20shadows%2C%20suspenseful%20cinematic%20lighting&width=800&height=600&seq=expose-card-08&orientation=landscape',
    time: '5小时前',
    reads: '342.7万',
  },
];

export const hotRankings = {
  todayReads: '10万+',
  todayReadsLabel: '今日阅读量',
  realtimeDiscussions: '5,200+',
  realtimeDiscussionsLabel: '实时讨论帖',
  exclusiveScoops: '300+',
  exclusiveScoopsLabel: '独家首发爆料',
};

export const trackingTopics = [
  {
    id: 1,
    title: '某顶流主播直播间翻车实录',
    summary: '直播间突然断线后，网友发现该主播账号已被平台永久封禁。粉丝群炸锅，超话瞬间涌入数十万讨论...',
    user: '吃瓜第一线',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20with%20mysterious%20vibe%2C%20dark%20silhouette%20on%20gradient%20pink%20background%2C%20minimalist%20design%2C%20modern%20flat%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '2分钟前',
    heat: 5,
  },
  {
    id: 2,
    title: '某女星深夜发文暗示离婚',
    summary: '该女星凌晨发布一段意味深长的文字，粉丝纷纷解读为婚变信号。其丈夫社交账号已清空所有合照...',
    user: '八卦雷达',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20detective%20style%20avatar%2C%20magnifying%20glass%20icon%2C%20dark%20background%20with%20subtle%20pink%20glow%2C%20minimalist%20modern%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '8分钟前',
    heat: 5,
  },
  {
    id: 3,
    title: '综艺节目录制现场导演组内讧',
    summary: '据现场观众爆料，节目总导演与执行导演在录制过程中发生激烈争执，导致录制延迟两小时...',
    user: '圈内老鬼',
    avatar: 'https://readdy.ai/api/search-image?query=Mysterious%20insider%20avatar%20with%20shadow%20face%2C%20dark%20gradient%20background%2C%20minimalist%20style%2C%20modern%20illustration%2C%20subtle%20warm%20accent&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '15分钟前',
    heat: 4,
  },
  {
    id: 4,
    title: '某网红品牌涉嫌虚假宣传被立案',
    summary: '市监局已正式立案调查该品牌夸大功效的宣传行为，涉及金额或达数千万元...',
    user: '真相挖掘机',
    avatar: 'https://readdy.ai/api/search-image?query=Investigative%20journalist%20avatar%20with%20notepad%2C%20dark%20background%2C%20minimalist%20modern%20illustration%2C%20professional%20vibe&width=80&height=80&seq=avatar-04&orientation=squarish',
    time: '22分钟前',
    heat: 5,
  },
  {
    id: 5,
    title: '全球巡演中国站门票秒空内幕',
    summary: '黄牛被曝与主办方内部勾结，大量门票在开售前已被锁定。粉丝联名要求主办方给出解释...',
    user: '黄牛克星',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20activist%20avatar%2C%20fist%20raised%20silhouette%2C%20dark%20gradient%2C%20minimalist%20modern%20illustration%2C%20rebellious%20energy&width=80&height=80&seq=avatar-05&orientation=squarish',
    time: '30分钟前',
    heat: 4,
  },
  {
    id: 6,
    title: '古装剧女主替身演员曝光行业内幕',
    summary: '替身演员接受专访，揭露剧组对替身演员的不公待遇，引发行业广泛关注...',
    user: '片场一线',
    avatar: 'https://readdy.ai/api/search-image?query=Film%20crew%20worker%20avatar%2C%20clapperboard%20icon%2C%20dark%20background%20with%20subtle%20warm%20glow%2C%20minimalist%20modern%20illustration&width=80&height=80&seq=avatar-06&orientation=squarish',
    time: '38分钟前',
    heat: 3,
  },
];

export const categories = [
  {
    slug: 'wanghong',
    title: '网红黑料 / 实时更新',
    description: '头部主播、短视频达人、社交媒体网红的最新爆料与争议事件追踪',
    icon: 'ri-fire-line',
  },
  {
    slug: 'mingxing',
    title: '明星八卦 / 一线情报',
    description: '影视明星、歌手、偶像团体的一手八卦与独家内幕消息',
    icon: 'ri-star-line',
  },
  {
    slug: 'shehui',
    title: '社会热点 / 深度挖掘',
    description: '社会热点事件、争议话题、公共事件的独家视角与深度追踪',
    icon: 'ri-eye-line',
  },
  {
    slug: 'yule',
    title: '娱乐圈 / 内幕揭秘',
    description: '影视综艺、音乐节、颁奖礼等娱乐圈大小事件的幕后真相',
    icon: 'ri-flashlight-line',
  },
];

export const navItems = [
  { label: '网红黑料', slug: 'wanghong' },
  { label: '明星八卦', slug: 'mingxing' },
  { label: '社会热点', slug: 'shehui' },
  { label: '娱乐圈内幕', slug: 'yule' },
];

export const footerLinks = {
  col1: [
    { label: '关于我们', href: '/about' },
    { label: '免责声明', href: '#' },
    { label: '投稿指南', href: '#' },
    { label: '全站搜索', href: '#' },
  ],
  col2: [
    { label: '网红黑料', href: '#' },
    { label: '明星八卦', href: '#' },
    { label: '社会热点', href: '#' },
    { label: '娱乐圈内幕', href: '#' },
  ],
  col3: [
    { label: '隐私政策', href: '#' },
    { label: '商务合作', href: '#' },
    { label: '广告服务', href: '#' },
    { label: 'RSS订阅', href: '#' },
  ],
};